module.exports = __webpack_public_path__ + "c530e4f178e996363eb8cbe80aab64a9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/access.svg
// module id = Dstl
// module chunks = 0